export const AppConfig = {
  googleApiKey: "AIzaSyDDAfrPKcVxx096l5SHZvoaWt7d-wrag-8",
  abacusCoreApiBaseUrl:
    process.env.NODE_ENV === "production"
      ? "https://us-central1-abacus-company-project.cloudfunctions.net/"
      : "https://us-central1-abacus-company-project.cloudfunctions.net/",
  ForceUseSandboxPayment:
    process.env.NODE_ENV === "production"
      ? "true"
      : "true",
  isBranded: "true",
  firebaseApiKey: "AIzaSyCGhJa8iZM_JU3UvEQ37gz5qOrQbwOdcEQ",
  firebaseProjectId: "abacus-online-ordering-test",
  firebaseMessagingSenderId: "1087170880950",
  stripeToken:
    process.env.NODE_ENV === "production"
      ? "pk_test_Gkme8Wh8YEFLCeX9OP3duTTe"
      : "pk_test_Gkme8Wh8YEFLCeX9OP3duTTe",
  stripeTestToken: "pk_test_Gkme8Wh8YEFLCeX9OP3duTTe",
  isRolldStore: "false",
  newUI: "",
  payAtTable:
    process.env.NODE_ENV === "production"
      ? "https://pay-dev.abacus.co/"
      : "https://pay-dev.abacus.co/",
  appleWalletFunctionApiBaseUrl:
    process.env.NODE_ENV === "production"
      ? "https://apple-wallet-mo4mvob2da-uc.a.run.app/"
      : "https://apple-wallet-mo4mvob2da-uc.a.run.app/",
  googleWalletFunctionApiBaseUrl:
    process.env.NODE_ENV === "production"
      ? "https://google-wallet-mo4mvob2da-uc.a.run.app/"
      : "https://google-wallet-mo4mvob2da-uc.a.run.app/",
  bugFenderApiKey: "aJgMuctkrEEABvVH2EYZEfZdmDDWqbbI",
  databaseURL:
    process.env.NODE_ENV === "production"
      ? "https://abacus-online-ordering.firebaseio.com/"
      : "https://abacus-cloudorders-development.firebaseio.com/",
  newOOStores:
    process.env.NODE_ENV === "production"
      ? ""
      : "2086324",
  orderupBlue:
      process.env.NODE_ENV === "production"
        ? "https://ou-dev.abacus.co"
        : "https://ou-dev.abacus.co",
};
